// @flow

import type { NotificationState } from './state'

export const getters = {
  isShowingLeadsToNoRecommendation (state: NotificationState): boolean {
    return state.notification.leadsToNoRecommendation ?? false
  }
}
